import { createStore } from 'vuex'
import authModule from './modules/auth'
import notificationModule from './modules/notification'
import settingsModule from './modules/settings'

const store = createStore({
  state () {
    return {
      appName: process.env.VUE_APP_NAME,
      reload: false
    }
  },
  mutations: {
    setReload(state, payload) {
      state.reload = payload;
    },
  },
  actions: {

  },
  getters: {
    getAppName: (state) => state.appName,
    getReload: (state) => state.reload,
  },

  modules: {
    auth: authModule,
    notification: notificationModule,
    settings: settingsModule,
  }
})

export default store